import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEditLine = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.263 3.177a1.75 1.75 0 0 1 2.475 0l3.085 3.086a1.75 1.75 0 0 1 0 2.474L9.53 20.03a.75.75 0 0 1-.348.198l-6 1.5a.75.75 0 0 1-.91-.91l1.5-6a.75.75 0 0 1 .198-.348zm1.414 1.06a.25.25 0 0 0-.354 0L15.061 5.5 18.5 8.94l1.263-1.263a.25.25 0 0 0 0-.354zM17.439 10 14 6.56l-8.823 8.823-1.146 4.586 4.586-1.146zM14.25 21a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEditLine;
